import * as React from "react"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import { ICategory } from "shared/hubrise/models"
import { Category, Deal, Product } from "shared/hubrise/utils"

import { Products, StyledCategory, StyledProductOrDeal } from "../Styles"

const CategoryAndChildren = ({ category }: { category: ICategory }): JSX.Element => {
  const { catalog } = useEditor()
  const { variantRef } = useCatalogNavigation()

  const subcategories = Category.children(catalog, category)
  const deals = Deal.inCategory(catalog, Deal.isFakeDealCategory(category) ? null : category)
  const productAndDeals = [
    ...Product.inCategory(catalog, category).filter((product) => Product.isVisibleInPreview(product, variantRef)),
    ...deals.filter((deal) => Deal.isVisibleInPreview(deal, variantRef)),
  ]
  const isEmpty = subcategories.length === 0 && productAndDeals.length === 0

  return (
    <React.Fragment>
      <StyledCategory key={category.id} category={category} isEmpty={isEmpty} />

      {productAndDeals.length > 0 && (
        <Products>
          {productAndDeals.map((productOrDeal) => (
            <StyledProductOrDeal key={productOrDeal.id} productOrDeal={productOrDeal} />
          ))}
        </Products>
      )}

      {subcategories.map((child) => (
        <CategoryAndChildren key={child.id} category={child} />
      ))}
    </React.Fragment>
  )
}

export default CategoryAndChildren
